import {capitalize, dashToCamel} from '../utilities/convertCase';
import {generateId} from '../utilities/id';
import * as behaviorClasses from './classes';

export const initBehaviors = (context) => {
  let { behaviorInstances } = window.mosmosh;
  const attribute = 'data-behavior';
  let elements = [];

  if (context === undefined) {
    context = document.body;
  }

  elements = Array.prototype.slice.call(context.querySelectorAll(`[${attribute}]`));

  if (context.hasAttribute(attribute)) {
    elements.unshift(context);
  }

  elements.forEach((element) => {
    const contextBehaviors = element.getAttribute(attribute).split(' ');

    contextBehaviors.forEach((behavior) => {
      const behaviorClassName = capitalize(dashToCamel(behavior));
      const instanceId = generateId(5);
      const instanceAttribute = 'data-behavior-instance';
      const instanceAttributeCurrentValue = element.getAttribute(instanceAttribute) || '';

      if (!instanceAttributeCurrentValue.includes(behavior)) {
        let instanceAttributeNewValue = instanceAttributeCurrentValue ? instanceAttributeCurrentValue + ' ' : '';
        instanceAttributeNewValue += `${behavior}_${instanceId}`;

        element.setAttribute(instanceAttribute, instanceAttributeNewValue);

        if (behaviorClasses[behaviorClassName]) {
          behaviorInstances[`${behavior}_${instanceId}`] = new behaviorClasses[behaviorClassName](behavior, element);
        }
      }
    });
  });

};

export const destroyBehaviors = (context) => {
  const { behaviorInstances } = window.mosmosh;
  const attribute = 'data-behavior-instance';

  let elements = [];

  if (context === undefined) {
    context = document.body;
  }

  elements = Array.prototype.slice.call(context.querySelectorAll(`[${attribute}]`));

  if (context.hasAttribute(attribute)) {
    elements.unshift(context);
  }

  elements.forEach((element) => {
    const contextBehaviorInstances = element.getAttribute(attribute).split(' ');
    element.removeAttribute(attribute);

    contextBehaviorInstances.forEach((behaviorInstance) => {
      if (behaviorInstances[behaviorInstance]) {
        behaviorInstances[behaviorInstance].cleanup();
        behaviorInstances[behaviorInstance] = null;
        delete behaviorInstances[behaviorInstance];
      }
    });
  });
};

export const cleanupBehaviors = () => {
  const { behaviorInstances } = window.mosmosh;
  const attribute = 'data-behavior-instance';

  let documentBehaviorInstances = [];

  document.body.querySelectorAll(`[${attribute}]`).forEach((element) => {
    const elementBehaviorInstances = element.getAttribute(attribute).split(' ');

    elementBehaviorInstances.forEach((behaviorInstance) => {
      documentBehaviorInstances.push(behaviorInstance);
    });
  });

  Object.keys(behaviorInstances).forEach((instance) => {
    if (documentBehaviorInstances.indexOf(instance) === -1) {
      if (behaviorInstances[instance]) {
        behaviorInstances[instance].cleanup();
        behaviorInstances[instance] = null;
        delete behaviorInstances[instance];
      }
    }
  });
};
